<template>
  <div
    v-if="showIosInstall"
    class="text-caption d-flex align-center justify-space-between"
  >
    <!-- Popover icon with menu -->
    <v-menu
      v-model="showPopover"
      :close-on-content-click="false"
      offset-y
    >
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          class="ml-2"
          v-on="on"
        >
          <v-icon color="#101010">
            mdi mdi-download
          </v-icon>
        </v-btn>
      </template>

      <v-card
        class="pa-3"
        elevation="2"
        max-width="280"
      >
        <div
          class="text-caption"
          style="color: #fff"
        >
          To install this app, tap <strong>Share</strong>
          <img
            class="mx-1"
            width="20px"
            src="../../../assets//img/ios-share.png"
          >
          and then <strong>Add to Home Screen</strong>.
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'IosInstallPrompt',
  data () {
    return {
      showIosInstall: false,
      showPopover: false,
    };
  },
  mounted () {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIos = /iphone|ipad|ipod/.test(userAgent);
    const isInStandalone = 'standalone' in window.navigator && window.navigator.standalone;

    const hasInstalled = JSON.parse(localStorage.getItem('ios_installed'));

    if (isIos && !isInStandalone && !hasInstalled) {
      this.showIosInstall = true;
    }

    if (isIos && isInStandalone) {
      localStorage.setItem('ios_installed', JSON.stringify(true));
    }
  },
};
</script>

<style scoped>
.custom-ios-alert {
  background-color: #fff !important;
  color: #64ca7f !important;
  border-left: 4px solid #64ca7f !important;
  border: 1px solid #64ca7f;
}

.green-icon {
  color: #64ca7f !important;
  font-size: 28px;
}
</style>
